var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bodyShow)?_c('div',{staticClass:"main"},[_c('public-header',{attrs:{"colors":'#F0F0F0',"headimg":_vm.headImg}}),_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"list clearfix",class:{'on':_vm.list[_vm.list.length-1]==_vm.list[index]}},[_c('router-link',{attrs:{"to":{
        path: '/ta_project_details',
        query: {
          'cid': _vm.cid,
          'cpid': item.id,
          // 'ctype':(index==0?true:false)
          'ctype': false
        }
      }}},[_c('h2',[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"left pull-left clearfix"},[(item.groupCompleteCount)?_c('p',[_vm._v("小组完成人数："),_c('span',[_vm._v(_vm._s(item.groupCompleteCount))])]):_vm._e(),(item.endtime)?_c('p',[_vm._v("报告完成截止时间："),_c('span',[_vm._v(_vm._s(item.endtime))])]):_vm._e()]),_c('img',{staticClass:"pull-right clearfix",attrs:{"src":require("@a/right_.png"),"alt":""}})])],1)}),(_vm.complete)?_c('router-link',{class:['sub-btn',_vm.complete?'active':''],attrs:{"to":{
      path:'/person_report_new',
      query:{
        cid: _vm.cid
      }
    }}},[_vm._v("\n    领取个人报告\n  ")]):_c('a',{staticClass:"sub-btn"},[_vm._v("\n    领取个人报告\n  ")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }